import ToastEventBus from '@wholebodyapp/ui-components/src/toast-service/toast-event-bus.js';
import { UiToastSymbol } from './use-toast.js';

export default {
  install: (app) => {
    const ToastService = {
      add: (message) => {
        ToastEventBus.emit('add', message);
      },
      remove: (message) => {
        ToastEventBus.emit('remove', message);
      },
      removeGroup: (group) => {
        ToastEventBus.emit('remove-group', group);
      },
      removeAllGroups: () => {
        ToastEventBus.emit('remove-all-groups');
      }
    };

    app.config.globalProperties.$toast = ToastService;
    app.provide(UiToastSymbol, ToastService);
  }
};
